<template>

  <div class="form-field" :class="classes">
    <div class="form-label" v-if="label">{{ label }}</div>
    <div class="form-input">

      <div class="form-dropdown" @click="toggleDropdown" :class="{'is_open': is_open}" ref="formDropdown">

        <div v-if="internalValue === item.id" v-for="item in options" class="form-dropdown-item">
          <icon :name="item.icon" :color="item.color"/>
          <label>
            <strong>{{ item.title }} <i>{{ item.id }}</i></strong>
            <p v-if="item.description">{{ item.description }}</p>
          </label>
        </div>
        <div v-if="!internalValue" class="form-dropdown-empty">Aucune option sélectionnée</div>

        <div class="form-dropdown-button">
          <icon name="chevron-down"/>
        </div>

        <ul class="form-dropdown-items">
          <li v-for="item in options" @click="selectItem(item.id)" class="form-dropdown-item" :disabled="item.id === internalValue">
            <icon :name="item.icon" :color="item.color"/>
            <label>
              <strong>{{ item.title }} <i>{{ item.id }}</i></strong>
              <p v-if="item.description">{{ item.description }}</p>
            </label>
          </li>
        </ul>
      </div>
    </div>

    </div>
</template>

<script>
export default {
  name: 'FormDropdown',
  props: ['value', 'options', 'callback', 'classes','label'],
  data: function () {
    return {
      internalValue: null,
      is_open: false
    }
  },
  mounted: function () {
    document.addEventListener('click', this.documentClick);
  },
  computed: {
    selectedItem: function(){
      let s = null;
      for(let item of this.options){
        if( item.id == this.internalValue ){
          s = item;
          break;
        }
      }
      return s;
    }
  },
  methods: {
    selectItem: function(id){
      this.internalValue = id;
      this.$emit('input', id);
      this.$parent.$forceUpdate();
      if( this.onChange ){
        this.callback(newVal)
      }
    },
    toggleDropdown: function(){
      this.is_open = !this.is_open;
    },
    documentClick(e) {
      var el = this.$refs.formDropdown,
          target = e.target;
      if(el !== target && !el.contains(target)) {
        this.is_open = false;
      }
    }
  },
  watch: {
    'value'(newVal, oldVal) {
      if( (newVal === null || newVal) && this.internalValue !== newVal ){
        this.internalValue = newVal;
      }
    },
    /*
    'internalValue'(newVal, oldVal) {
      if( newVal === null || newVal ){
        this.$emit('input', newVal);
        if( this.onChange ){
          this.callback(newVal)
        }
      }
    }*/
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/Dropdown.vue